import { AxiosRequestConfig, AxiosResponse } from "axios"
import { IEntityGST, IGenericResponseGST } from "services/core/genericEntityGST"
import { RequestGST } from "services/Instances"

export const SegurancaDoTrabalhoServices = () => {
  const getItensAnexadosByFilter = async (params: IGetItensAnexadosByFilterParams): Promise<AxiosResponse<IEntityGST<IGetItensAnexadosByFilterResponse[]>>> =>
    await RequestGST.get('ItensAnexados/GetItensAnexadosByFilter', { params })

  const inserirDocumentoItem = async (body: IInserirDocumentoItem[],options?: AxiosRequestConfig): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.patch('ItensAnexados/InserirDocumentoItemAnexado', body,options)

  return {
    getItensAnexadosByFilter,
    inserirDocumentoItem,
  }
}

export interface IInserirDocumentoItem {
  idAmrItemSegurancaContrato: number
  idContrato: number
  arquivo: string
  nmArquivo: string
}

export interface IGetItensAnexadosByFilterParams {
  txPesquisaGeral: string
  idUsuario: number
}

export interface Anexo {
  idAmrItemSegurancaContrato: number;
  txDescricaoRelItemSeguranca: string;
  txJustificativa: string;
  cdGedExternalId: string;
  cdStatus: string;
  dtAnexado: Date;
  dtRetorno: Date;
  // Local
  base64?: string
  filename?: string
}

export interface IGetItensAnexadosByFilterResponse {
  anexos: Anexo[];
  idContrato: number;
  cdContrato: string;
  txObjetoContrato: string;
  dtInicioVigencia: Date;
  dtFimVigencia: Date;
  nmFornecedor: string;
}
